module.exports = __webpack_public_path__ + "img/logo.977c55bc.png";